/*
 * Jira Ticket:
 * Created Date: Fri, 21st Feb 2020, 10:06:39 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useTranslate } from 'react-admin';

import CardIcon from 'Components/CardIcon';

const useStyles = makeStyles({
  main: {
    flex: '1',
    marginRight: '1em',
    marginTop: 20,
    width: 500,
  },
  card: {
    overflow: 'inherit',
    textAlign: 'right',
    padding: 16,
    minHeight: 52,
  },
  title: {},
});

const StatisticsCard = ({ icon, bgColour, value, description }) => {
  const translate = useTranslate();
  const classes = useStyles();
  return (
    <div className={classes.main}>
      <CardIcon Icon={icon} bgColour={bgColour} />
      <Card className={classes.card}>
        <Typography className={classes.title} color="textSecondary">
          {translate(description)}
        </Typography>
        <Typography variant="h5" component="h2">
          {value}
        </Typography>
      </Card>
    </div>
  );
};

export default StatisticsCard;
